import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-thirteen',
  templateUrl: './home-page-thirteen.component.html',
  styleUrls: ['./home-page-thirteen.component.scss']
})
export class HomePageThirteenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
